// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index-module__heading--3dUjS{font-size:24px;line-height:1.04;font-weight:700;letter-spacing:-.03em}.index-module__text--3UgGm{font-size:18px;line-height:25px;font-weight:400;letter-spacing:-.02em}.index-module__wrapper--3qhCN{text-align:center}.index-module__heading--3dUjS{margin-bottom:10px}.index-module__text--3UgGm{margin-bottom:40px}", ""]);
// Exports
exports.locals = {
	"heading": "index-module__heading--3dUjS",
	"text": "index-module__text--3UgGm",
	"wrapper": "index-module__wrapper--3qhCN"
};
module.exports = exports;
